/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

/** Titles of the RI maritime areas relevant to the conflict zone. */
export const IRAN_CONFLICT_AREA_TITLES = [
  'Red Sea',
  'Persian Gulf',
  'Indian Ocean',
  'Mediterranean',
] as const;

/** Generic state for a focused map region — currently used by Iran Conflict. */
export interface FocusRegionState {
  active: boolean;
  /** The resolved GeoJSON Polygon used for spatial filtering — set when focus region activates. */
  polygon: GeoJSON.Polygon | null;
  /** ISO date string — only news items on or after this date are shown when the focus region is active. */
  startDate: string | null;
}

export const INITIAL_FOCUS_REGION_STATE: FocusRegionState = {
  active: false,
  polygon: null,
  startDate: null,
};

const focusRegionSlice = createSlice({
  name: 'focusRegion',
  initialState: INITIAL_FOCUS_REGION_STATE,
  reducers: {
    setFocusRegionActive: (state, action: PayloadAction<boolean>) => {
      state.active = action.payload;
      if (!action.payload) {
        state.polygon = null;
        state.startDate = null;
      }
    },
    setFocusRegionPolygon: (
      state,
      action: PayloadAction<GeoJSON.Polygon | null>
    ) => {
      state.polygon = action.payload;
    },
    setFocusRegionStartDate: (state, action: PayloadAction<string | null>) => {
      state.startDate = action.payload;
    },
  },
});

export const {
  setFocusRegionActive,
  setFocusRegionPolygon,
  setFocusRegionStartDate,
} = focusRegionSlice.actions;

// Aliases kept for Iran Conflict callers — the generic mechanism is focusRegion
export const setIranConflictActive = setFocusRegionActive;
export const setIranConflictPolygon = setFocusRegionPolygon;

export default focusRegionSlice.reducer;
